var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-slide-y-reverse-transition',{attrs:{"mode":"out-in"}},[(!_vm.categories.length || (!_vm.categories.length && _vm.loadingCategories))?_c('v-messages'):_vm._e(),_c('div',[_c('v-categories'),_c('v-load-more')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }